{
  "form": {
    "required": "{name} ist erforderlich",
    "incomplete": "Leider sind nicht alle Felder korrekt ausgefüllt.",
    "invalidPhoneNumber": "Ungültige Rufnummer",
    "phonePlaceholder": "Ländervorwahlen suchen",
    "oneRequired": "Nur eines der Felder ist obligatorisch"
  },
  "orderFlow": {
    "error": {
      "description": "Es ist etwas passiert. Ihre Bestellung war unvollständig. Bitte versuchen Sie es erneut."
    },
    "confirmPayment": {
      "description": "Sie werden in Kürze zum Zahlungsportal weitergeleitet.",
      "redirectToGateway": "Weiterleitung zum Zahlungs-Gateway"
    },
    "complete": {
      "description": "Ihre Bestellung wurde erfolgreich abgeschlossen.",
      "receiptIsReadyToDownload": "Ihre Quittung ist fertig und Sie können sie auf Ihr Gerät herunterladen."
    },
    "showPaymentFailure": {
      "description": "Ihre Zahlung wurde nicht erfolgreich abgeschlossen."
    },
    "waitForPayment": {
      "description": "Wir warten auf das Ergebnis Ihrer Zahlung."
    },
    "waitForReceipt": {
      "description": "Wir erstellen eine Quittung. Warten Sie eine Minute."
    },
    "timeout": {
      "description": "Das Zeitlimit wurde überschritten. Wir werden Sie über das Ergebnis benachrichtigen."
    }
  },
  "cancel": "Abbrechen",
  "no": "Nein",
  "yes": "Ja",
  "order": "Bestellung",
  "emailAddress": "E-Mail Adresse",
  "phoneNumber": "Telefonnummer",
  "somethingHappenedTryItAgain": "Es ist etwas passiert. Bitte versuchen Sie es erneut.",
  "previousTab": "Zurück",
  "nextTab": "Weiter",
  "goBack": "Zurückgehen",
  "download": "Herunterladen",
  "noMatches": "Keine Treffer",
  "firstName": "Vorname",
  "lastName": "Nachname",
  "companyName": "Firmenname",
  "regNum": "Registrierung (HRA, o. äh.)",
  "regLocation": "Register Ort",
  "vat": "USt-ID (DE xxxxxxxxx)",
  "taxId": "Alternativ Steuernummer",
  "jobPosition": "Pracovní pozice",
  "attentionTo": "Věnovat pozornost",
  "street": "Straße",
  "houseNum": "Hausnummer",
  "city": "Ort",
  "zip": "PLZ",
  "country": "Land",
  "accept": "Akzeptieren",
  "refuse": "Ablehnen",
  "localeSettings": {
    "title": "Spracheinstellungen",
    "localeSelect": "Sprache verwenden"
  },
  "baasSimManagementLite": {
    "simAuthenticationFailed": "SIM-Authentifizierung fehlgeschlagen",
    "simLoading": "SIM-Laden...",
    "noActivePackage": "Kein Paket",
    "availablePackages": "Verfügbare Pakete",
    "simLoadDataFailed": "Laden der SIM-Daten fehlgeschlagen",
    "inactiveAndSynchronizationInProgress": "Die SIM-Karte ist nicht aktiv. Es kann bis zu 2 Stunden dauern, den Status zu synchronisieren.",
    "login": {
      "authorizationCode": "Authorization Code",
      "authorizationCodeValidation": "Authorization code is max 6 length alphanum code."
    },
    "loginType": {
      "go": "Go",
      "identificationCode": "SIM-ID",
      "insertSimIdentification": "Bitte SIM-ID eingeben",
      "invalidIdentificationCode": "Ungültige SIM-ID"
    },
    "package": {
      "purchaseInProgress": "Laufender Kauf",
      "buyFor": "Kaufen für",
      "inactiveAndSynchronizationInProgress": "Die SIM-Karte ist nicht aktiv. Es kann bis zu 2 Stunden dauern, den Status zu synchronisieren."
    },
    "packageOrder": {
      "description": "Bitte geben Sie Ihre E-Mail-Adresse ein, bevor Sie zum Zahlungsgateway weitergeleitet werden, an das wir den Zahlungsnachweis senden werden.",
      "requiredTermsAndConditions": "Bevor Sie ein Paket bestellen, müssen Sie den Allgemeinen Geschäftsbedingungen zustimmen",
      "showBillingInfo": "Rechnungsinformationen ausfüllen",
      "billingName": "Name"
    },
    "unprocessedPackages": {
      "foundUnprocessed": "Die Bestellung wird gerade bearbeitet. Dieser Vorgang kann ein paar Minuten dauern. Bitte warten Sie.",
      "warnUnprocesse": "Die Bestellung wird gerade bearbeitet. Sind Sie sicher, dass Sie ein weiteres Paket bestellen möchten?"
    },
    "usageBar": {
      "total": "Insgesamt",
      "used": "Verbraucht",
      "remaining": "Bleibt",
      "validTo": "Geltungsdauer bis"
    }
  },
  "proposal": {
    "acceptForm": {
      "availableOffers": "Verfügbare Angebote",
      "companyInformations": "Informationen zum Unternehmen",
      "address": "Adresse",
      "contactPersonInformation": "Informationen zur Kontaktperson",
      "proposalAccpetFailed": "Annahme des Angebots gescheitert",
      "alternative": "Alternativen",
      "comment": "zusätzliche Bemerkungen",
      "availableOffersHint": "Sie ein oder mehrere  Angebote um diese anzunehmen",
      "tabs": {
        "offerAndCompany": "Angebot und Unternehmen",
        "addresses": "Anschriften",
        "bankDetail": "Bankverbindung"
      },
      "personalCustomerPassword": {
        "label": "Persönliches Kundenkennwort",
        "hint": "Wird benötigt damit Sie sich bei unserem Support legitimieren können"
      },
      "invoiceReceipt": {
        "title": "Rechnungsempfang",
        "emailAddress": "E-Mail Adresse für Rechnungsempfang",
        "monthlyEmailNotificationNotIncludePDF": "Die monatliche E-Mail Benachrichtigung soll keine E-Rechnungskopie als PDF enthalten"
      },
      "billingAddress": {
        "title": "Rechnungsdaten",
        "sameAsCustomerInformation": "wie Kundendaten"
      },
      "deliveryAddress": {
        "title": "Lieferadresse",
        "sameAsCustomerInformation": "wie Kundendaten"
      },
      "adminAccessCredentials": {
        "title": "SIM Admin / Zugangsdaten myFUSION Portal",
        "hint": "Der SIM Admin erhält volle Rechte innerhalb des myFUSION Portals, weitere Benutzer mit unterschiedlichen Berechtigungen können vom SIM Admin selbst erstellt werden.",
        "firstName": "SIM Admin Vorname",
        "lastName": "SIM Admin Nachname",
        "jobPosition": "SIM Admin Funktion / Position",
        "phoneNumber": "SIM Admin Rufnummer",
        "emailAddress": "SIM Admin E-Mail"
      },
      "bankDetails": {
        "title": "Bankverbindung",
        "accountHolder": "Kontoinhaber",
        "bankName": "Kreditinstitut",
        "bic": "BIC",
        "iban": "IBAN",
        "street": "Straße (Kontoinhaber)",
        "postalCode": "PLZ (Kontoinhaber)",
        "city": "Ort (Kontoinhaber)"
      },
      "companyVerification": {
        "title": "Unternehmensnachweis",
        "hint": "Bitte geben Sie mindestens eines der folgenden an: Unternehmensregister EUID oder Gewerbeschein.",
        "euid": "Unternehmensregister EUID",
        "euidHelp": "European Unique Identifier (z.B. DEXXX...)",
        "tradeLicense": "Gewerbeschein (PDF)",
        "tradeLicenseHelp": "Laden Sie Ihren Gewerbeschein als PDF-Datei hoch",
        "validationRequired": "Bitte geben Sie entweder eine EUID oder einen Gewerbeschein an",
        "invalidFileType": "Es werden nur PDF-Dateien akzeptiert"
      },
      "countOfSims": "Die Anzahl der bestellten SIM-Karten darf nicht größer sein als das Dreifache der ursprünglichen Bestellung",
      "simsAmount": "Anzahl SIM-Karten",
      "differentSimsAmount": "Bestellen Sie eine andere Anzahl SIM-Karten",
      "acceptProposal": "Angebot annehmen"
    },
    "refuseDialog": {
      "refuseDialogTitle": "Bestätigung der Ablehnung des Angebots"
    },
    "refuseForm": {
      "reasonText": "Bitte geben Sie den Grund für die Ablehnung des Angebots an",
      "refuseDialogText": "Sind Sie sicher, dass Sie das Angebot ablehnen wollen?",
      "proposalRefuseFailed": "Die Ablehnung des Angebots ist gescheitert"
    },
    "proposalLoading": "Angebot laden...",
    "proposalLoadDataFailed": "Laden der Angebotsdaten fehlgeschlagen",
    "proposalIsAccepted": "Der Angebot wird akzeptiert",
    "proposalIsRefused": "Der Angebot wird abgelehnt",
    "proposalExpired": "Das Angebot ist abgelaufen",
    "proposalNumber": "Angebot-Nr.",
    "validTo": "Gultig bis",
    "vop": {
      "disclaimer": "Alle Informationen zur Verarbeitung personenbezogener Daten und die geltenden Allgemeinen Geschäftsbedingungen (AGB) finden Sie in",
      "link": "diesem PDF"
    }
  },
  "languages": {
    "en": "English",
    "cs": "Čeština",
    "sk": "Slovenský",
    "pl": "Polski",
    "de": "Deutsch"
  }
}
